import Input from '@components/TextField'
import { UserListInterface } from '@hermes/types'
import { Box, Switch, Typography } from '@hermes/web-components'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { useUserToken } from '@hooks/useUserToken'
import { createUserList } from '@lib/services/user'
import getRegionFromLocale from '@lib/utils/getRegionFromLocale'
import { Dispatch, SetStateAction, useState } from 'react'

import { useLocale } from '@hooks/useLocale'
import { CreateButton, CreateListContainer } from './Create.styles'

interface CreateListProps {
  setRoute: Dispatch<SetStateAction<string>>
  lists: UserListInterface[]
  setLists: Dispatch<SetStateAction<UserListInterface[]>>
}

const CreateListRoute = ({ setRoute, lists, setLists }: CreateListProps) => {
  const [listName, setListName] = useState('')
  const [makeListPublic, setMakeListPublic] = useState(false)
  const [error, setError] = useState(true)
  const { token } = useUserToken()
  const { t } = useTranslateMessage()
  const locale = useLocale()
  const region = getRegionFromLocale(locale)

  const createList = () =>
    createUserList({
      token: String(token),
      title: listName,
      privateList: makeListPublic,
      country: region.toUpperCase()
    }).then((list) => {
      lists.push(list.data)
      setLists(lists)
      setRoute('main')
    })

  const listNameValidation = (
    value: string,
    setInputError: Dispatch<SetStateAction<boolean>>,
    setInputSuccess: Dispatch<SetStateAction<boolean>>
  ) => {
    if (value.length !== 0) {
      setInputSuccess(true)
      setError(false)
    } else {
      setInputError(true)
      setError(true)
    }
  }

  return (
    <Box>
      <CreateListContainer>
        <Input
          label={t({ id: 'modal.addBookToList.create.placeholder' })}
          validation={listNameValidation}
          required
          value={listName}
          onChange={setListName}
        />
        <Box m="16px 0" display="flex" alignItems="center" justifyContent="space-between">
          <Typography fontSize="14px" lineHeight="20px" fontWeight={500}>
            {t({ id: 'modal.addBookToList.create.makeListPublic' })}
          </Typography>
          <Switch onChange={(e, checked) => setMakeListPublic(checked)} />
        </Box>
      </CreateListContainer>
      <CreateButton disabled={error && !listName.length} onClick={createList}>
        {t({ id: 'modal.addBookToList.create.add' })}
      </CreateButton>
    </Box>
  )
}

export default CreateListRoute
